import PropTypes from "prop-types";

export const navMenuItem = PropTypes.shape({
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
});
